import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@devinforius/i-essentials';
import { TreeSelect } from 'primeng/treeselect';
import { ClassificationCodeDto, DropdownService, NatureDto, SourceDto } from 'src/app/shared/interfaces';
import { ServicesService } from 'src/app/shared/services/services.service';
import * as _ from 'underscore';
import { forkJoin } from 'rxjs';
import { UsersService } from 'src/app/shared/services/users.service';
import { UserDto } from 'src/app/shared/interfaces/users';
import { UserContact } from 'src/app/shared/models';
import { SourcesService } from 'src/app/shared/services/sources.service';
import { GlobalCentreNumerisationDTO } from 'src/app/shared/models/iCourrier/centre-numerisation/global-centre-numerisation';
import { NaturesService } from 'src/app/shared/services/natures.service';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ToBeCompletedFromScan } from 'src/app/shared/models/iCourrier/scans/to-be-completed-from-scan';
import { Scan as ScanDTO } from 'src/app/shared/models/iScanAPI/scan';
import { MailsService } from 'src/app/shared/services/mails.service';
import { ICourrierScanService } from 'src/app/shared/services/iCourrier-scan.service';
import { IScanAPIService } from 'src/app/shared/services/iscan.service';
import { MeService } from 'src/app/shared/services/me.service';
import { Router } from '@angular/router';
import { ScanSearchMailsDTO } from 'src/app/shared/interfaces/scans/scan-search-mail-dto.interface';
import { NumerisationCentersService } from 'src/app/shared/services/numerisation_centers.service';
import { ServicesOnlyParent, ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import {
  manageServicesSetAsTreeSelect,
  manageServicesToBeMerged,
  returnOnlyParentServices,
} from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { Scan, ScanSplit } from '@devinforius/i-scan';

@Component({
  selector: 'app-simple-mail-creation-modal',
  templateUrl: './simple-mail-creation-modal.component.html',
  styleUrls: ['./simple-mail-creation-modal.component.scss'],
})
export class SimpleMailCreationModalComponent {
  @ViewChild('treeSelect') treeSelect: TreeSelect;
  @Input() set scanSplit(value: ScanSplit) {
    this.chosenScanSplit = value;
    this.pageIsLoaded = false;
    this.getAllQueries();
  }
  @Input() originScan: ScanDTO;
  @Input() scan: Scan;
  @Output() public closeModal: EventEmitter<ScanSearchMailsDTO | null> = new EventEmitter();

  public chosenScanSplit: ScanSplit;

  public form = new UntypedFormGroup({
    ServiceProprietaireId: new UntypedFormControl(null, Validators.required),
    DatePostale: new UntypedFormControl(null),
    DateDocument: new UntypedFormControl(null),
    DateEcheance: new UntypedFormControl(null),
    DateEntree: new UntypedFormControl(null, Validators.required),
    Remarques: new UntypedFormControl(null),
    SourceId: new UntypedFormControl(null),
    NatureId: new UntypedFormControl(null),
    ReferenceRecommande: new UntypedFormControl(null),
    CentreNumerisationId: new UntypedFormControl(null),
    CentreNumKey: new UntypedFormControl(null),
    DestinataireContactId: new UntypedFormControl(null),
    ClassementId: new UntypedFormControl(null),
  });

  public selectedOption: { label: string; value: number; parentId: number } = null;
  public servicesFusionned: {
    label: string;
    value: number;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public servicesOnlyParent: ServicesOnlyParent[] = [];
  public services: ServicesPTreeSelect[] = [];
  public showAllServices = false;
  public displayWarningChildServiceDetected = false;

  public recipients: UserContact[];
  public sources: {
    label: string;
    value: number;
    displayRecommendedReference: boolean;
  }[];
  public showRecommendedReference = false;
  public scanningCenters: { label: string; value: string; item: GlobalCentreNumerisationDTO }[];
  public natures: { label: string; value: number }[];
  public classificationCodes: { label: string; value: number }[];

  public maxDateModified = moment().toDate();
  public maxDate = moment().toDate();

  public translationPlaceholderPTree: string;

  public pageIsLoaded = false;

  constructor(
    private servicesService: ServicesService,
    private numerisationCentersService: NumerisationCentersService,
    private usersService: UsersService,
    private sourcesServices: SourcesService,
    private translater: TranslateService,
    private naturesService: NaturesService,
    private classificationService: ClassificationsService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private iCourrierScanService: ICourrierScanService,
    private mailsService: MailsService,
    private iScanAPIService: IScanAPIService,
    private router: Router,
    private meService: MeService
  ) {}

  private getAllQueries(): void {
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');
    // To display the html we need to get all of those responses
    forkJoin({
      services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns(),
      meRightMails: this.meService.rightMailGlobal(),
      recipients: this.usersService.fetchUsersFromiAdmin({ Active: true }),
      sources: this.sourcesServices.fetchSources(),
      scanningCenters: this.numerisationCentersService.getGlobalCentreNumerisation(),
      natures: this.naturesService.fetchNatures(),
      classificationCodes: this.classificationService.fetchClassificationCodes(true),
    }).subscribe({
      next: (res) => {
        this.formatServices(res.services);
        this.showAllServices = !res.meRightMails.iScan.limitFirstLevelService;
        this.formatUsersForRecipientArray(res.recipients);
        this.formatSources(res.sources);
        this.formatScanningCenters(res.scanningCenters);
        this.formatNatures(res.natures);
        this.formatClassificationsCodes(res.classificationCodes);
        this.setDatas();
      },
    });
  }

  private formatServices(services: DropdownService[]): void {
    const datasForService = manageServicesSetAsTreeSelect(services, this.translater);
    this.services = datasForService.servicesForSingleCheck;
    this.servicesOnlyParent = returnOnlyParentServices(services);
    this.servicesFusionned = manageServicesToBeMerged(services);
  }

  private formatUsersForRecipientArray(recipients): void {
    this.recipients = [];
    recipients.forEach((user: UserDto) => {
      this.recipients.push(new UserContact(user));
    });
  }

  private formatSources(sources: SourceDto[]): void {
    this.sources = [];
    sources.forEach((source) => {
      this.sources.push({
        label: source.description,
        value: source.id,
        displayRecommendedReference: source.afficherReferenceRecommande,
      });
    });
    this.sources = _.sortBy(this.sources, 'label');
  }

  private formatScanningCenters(scanningCenters: GlobalCentreNumerisationDTO[]): void {
    this.scanningCenters = [];
    scanningCenters.forEach((scanningCenter) => {
      this.scanningCenters.push({ label: scanningCenter.description, value: scanningCenter.codeQr, item: scanningCenter });
    });
  }

  private formatNatures(natures: NatureDto[]): void {
    this.natures = [];
    natures.forEach((nature) => {
      this.natures.push({ label: nature.description, value: nature.id });
    });
    this.natures = _.sortBy(this.natures, 'label');
  }

  private formatClassificationsCodes(classificationCodes: ClassificationCodeDto[]): void {
    this.classificationCodes = [];
    classificationCodes.forEach((classificationCode) => {
      this.classificationCodes.push({
        label: classificationCode.code + (classificationCode.description ? ' (' + classificationCode.description + ')' : ''),
        value: classificationCode.id,
      });
    });
    this.classificationCodes = _.sortBy(this.classificationCodes, 'label');
  }

  private setDatas(): void {
    // Setting datas for services
    this.selectedOption = null;
    this.treeSelect.value = null;
    const labelTreeHtml = document.querySelectorAll('.treeSelect .p-treeselect-label');
    labelTreeHtml.length > 0 ? (labelTreeHtml[0].innerHTML = this.translater.translate('pleaseSelectAService')) : null;

    // Patching all datas for the form
    const qrCode = this.explodeQrCode(this.chosenScanSplit.mainCode);
    this.form.patchValue({
      DateEntree: new Date(),
      DateDocument: null,
      DateEcheance: null,
      DatePostale: null,
      Remarques: null,
      ServiceProprietaireId: this.extractQrCodeDataFromArray(qrCode, 'SVCID') ? +this.extractQrCodeDataFromArray(qrCode, 'SVCID') : null,
      CentreNumKey: this.extractQrCodeDataFromArray(qrCode, 'CENTERNUM') ? this.extractQrCodeDataFromArray(qrCode, 'CENTERNUM') : null,
      SourceId: this.extractQrCodeDataFromArray(qrCode, 'SRCID') ? +this.extractQrCodeDataFromArray(qrCode, 'SRCID') : null,
      ClassementId: this.extractQrCodeDataFromArray(qrCode, 'CODECLASSID') ? +this.extractQrCodeDataFromArray(qrCode, 'CODECLASSID') : null,
      DestinataireContactId: this.extractQrCodeDataFromArray(qrCode, 'DESTCNTID') ? +this.extractQrCodeDataFromArray(qrCode, 'DESTCNTID') : null,
      NatureId: null,
    });
    if (this.extractQrCodeDataFromArray(qrCode, 'SRCID')) {
      this.changeSource({ value: +this.extractQrCodeDataFromArray(qrCode, 'SRCID') });
    }
    this.pageIsLoaded = true;
  }

  explodeQrCode(qrCode): Array<{ tag: string; content: string }> {
    if (qrCode) {
      const regexp = /<([^>]+)>(.*?)<\/\1>/g;
      const resultsObtained = [];
      let match;
      while ((match = regexp.exec(qrCode)) !== null) {
        const tag = match[1]; // La balise trouvée
        const content = match[2]; // Le contenu entre les balises
        resultsObtained.push({ tag: tag, content: content });
      }
      return resultsObtained;
    } else return [];
  }

  extractQrCodeDataFromArray(
    array: Array<{ tag: string; content: string }>,
    type: 'SVCID' | 'CENTERNUM' | 'SRCID' | 'CODECLASSID' | 'DESTCNTID'
  ): string | number | null {
    if (array?.length > 0 && type) {
      const dataToExtract = array.find((x) => x.tag === type);
      if (dataToExtract) {
        if (type === 'SVCID') {
          this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === +dataToExtract.content));
          if (!this.showAllServices) {
            //Si on n'affiche pas les services enfants alors faut remonter jusqu'au parent 0
            if (this.selectedOption.parentId > 0) {
              this.displayWarningChildServiceDetected = true;
              const parentOriginal = this.getBackToOriginalParent(this.selectedOption);
              this.selectedOption = parentOriginal;
              this.setSelectedOptionLabelForExtractQrCode();
              return parentOriginal.value;
            } else {
              this.setSelectedOptionLabelForExtractQrCode();
              return dataToExtract.content;
            }
          } else {
            //Si on affiche tout, on va juste vérifier qu'on reçoit quelque chose
            this.setSelectedOptionLabelForExtractQrCode();
            return dataToExtract.content;
          }
        } else {
          return dataToExtract.content;
        }
      } else {
        return null;
      }
    } else return null;
  }

  /**
   * getBackToOriginalParent
   * @description
   *  Go back to the original parent of a service from the fusionned list
   *  This is useful when we want to get the original parent of a service because
   *  we have a list of services that have been fusionned on multiple levels
   * @param {label:string, value : number, parentId: number} item - Item to
   *  get the original parent from
   * @returns {{label:string, value : number, parentId: number}} - The original
   *  parent of the item
   */
  getBackToOriginalParent(item: { label: string; value: number; parentId: number }): {
    label: string;
    value: number;
    parentId: number;
  } {
    const parent = _.first(this.servicesFusionned.filter((x) => x.value === item.parentId));
    if (parent.parentId > 0) {
      return this.getBackToOriginalParent(parent);
    } else {
      return parent;
    }
  }

  setSelectedOptionLabelForExtractQrCode(): void {
    if (this.selectedOption) {
      const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
      labelTreeHtml[0].innerHTML = this.selectedOption?.label;
    }
  }

  checkIfSomeScanningCenterExist(): string {
    return this.scanningCenters?.length > 0
      ? this.translater.translate('iScan.action.selectScanningCenter')
      : this.translater.translate('iScan.information.noScanningCenterAvailable');
  }

  checkIfSomeNatureExist(): string {
    return this.natures?.length > 0
      ? this.translater.translate('iScan.action.selectNature')
      : this.translater.translate('iScan.information.noNatureAvailable');
  }

  changeSource(event): void {
    if (event?.value) {
      const source = this.sources.find((source) => source.value === event.value);
      this.showRecommendedReference = source.displayRecommendedReference;
    } else {
      this.showRecommendedReference = false;
    }
  }

  checkIfSomeSourceExist(): string {
    return this.sources?.length > 0
      ? this.translater.translate('iScan.action.selectSource')
      : this.translater.translate('iScan.information.noSourceAvailable');
  }

  checkIfSomeRecipientExist(): string {
    return this.recipients?.length > 0
      ? this.translater.translate('iScan.action.selectRecipient')
      : this.translater.translate('iScan.information.noRecipientAvailable');
  }

  checkIfSomeClassificationCodeExist(): string {
    return this.classificationCodes?.length > 0
      ? this.translater.translate('iScan.action.selectClassificationCode')
      : this.translater.translate('iScan.information.noClassificationCodeAvailable');
  }

  /**
   * * Method to add p-highlight class to current service selected
   */
  onShowTreeSelect(): void {
    if (this.selectedOption) {
      const aTags = document.getElementsByClassName('p-treenode-content');
      let found;
      if (aTags && aTags.length > 0) {
        for (let i = 0; i < aTags.length; i++) {
          if (aTags[i].textContent == this.selectedOption.label) {
            found = aTags[i];
            found.classList.add('p-highlight');
            break;
          }
        }
      }
    }
  }

  select(event): void {
    if (event.node?.value) {
      if (this.selectedOption?.value !== event.node.value) {
        this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === event.node.value));
        const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.selectedOption.label;
        this.form.patchValue({
          ServiceProprietaireId: event.node.value,
        });
      } else {
        this.selectedOption = null;
        const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
        this.treeSelect.value = [];
        this.form.patchValue({
          ServiceProprietaireId: null,
        });
      }
    }
  }

  changeMaxDateDocumentsClick(event): void {
    this.maxDateModified = moment(event, 'DD/MM/YYYY').toDate();
  }

  changeMaxDateDocuments(event): void {
    const momentDate = moment(event.target.value, 'DD/MM/YYYY', true);
    if (momentDate.isValid() && momentDate.isBefore(this.maxDate)) {
      this.maxDateModified = moment(event.target.value, 'DD/MM/YYYY').toDate();
    }
  }

  emitCloseModal(newMail?: ScanSearchMailsDTO): void {
    this.closeModal.emit(newMail ? newMail : null);
  }

  createFromScan(): void {
    this.spinner.show();
    if (this.form.valid) {
      this.scan.splits = this.scan.splits.map((split) => {
        if (split.guid === this.chosenScanSplit.guid) split.lock = true;
        return split;
      });
      this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe({
        next: () => {
          const index = this.originScan.splits.findIndex((split) => split.guid === this.chosenScanSplit.guid);
          const metaData = this.originScan.splits[index]?.mainCode;

          const datasToSend: ToBeCompletedFromScan = {
            scanLot: this.originScan.guid,
            scanLotCompleted: this.scan.splits.filter((split) => split.guid !== this.chosenScanSplit.guid).every((split) => split.lock),
            splits: [
              {
                split: this.chosenScanSplit.guid,
                barCode: metaData,
                centreNumerisationId: this.scanningCenters.find((x) => x.item.codeQr === this.form.value.CentreNumKey)?.item.id,
                destinataireContactId: this.form.value.DestinataireContactId,
                serviceProprietaireId: this.form.value.ServiceProprietaireId,
                typeEntrantSortant: 'E',
                natureId: this.form.value.NatureId,
                sourceId: this.form.value.SourceId,
                referenceRecommande: this.form.value.ReferenceRecommande,
                remarques: this.form.value.Remarques,
                dateEntree: this.form.value.DateEntree ? moment(this.form.value.DateEntree).format('YYYY-MM-DD') : null,
                dateDocument: this.form.value.DateDocument ? moment(this.form.value.DateDocument).format('YYYY-MM-DD') : null,
                dateEcheance: this.form.value.DateEcheance ? moment(this.form.value.DateEcheance).format('YYYY-MM-DD') : null,
                datePostale: this.form.value.DatePostale ? moment(this.form.value.DatePostale).format('YYYY-MM-DD') : null,
                classementId: this.form.value.ClassementId,
                fileDescription: this.chosenScanSplit.name,
              },
            ],
          };
          this.iCourrierScanService.aCompleterFromScan(datasToSend).subscribe({
            next: (res) => {
              this.toastr
                .success(
                  this.translater.translate('iScan.information.clickHereToOpenMailFile'),
                  this.translater.translate('iScan.information.mailWasSuccessfullyCreated', { mailId: res[0].mail.id })
                )
                .onTap.subscribe({
                  next: () => {
                    sessionStorage.setItem('Tag', 'ACompleter');
                    window.open('/private/ic/courriers/ACompleter/' + res[0].mail.id, '_blank');
                  },
                });
              if (datasToSend.scanLotCompleted) {
                this.toastr.success(this.translater.translate('iScan.information.scanCompleted'), this.translater.translate('iScan.success.success'));
                this.router.navigateByUrl('private/ic/home-scans');
              } else {
                this.mailsService.searchMailsToAttach({ ids: [res[0].mail.id] }).subscribe({
                  next: (mails) => {
                    this.emitCloseModal(mails[0]);
                    this.spinner.hide();
                    this.form.reset();
                  },
                });
              }
            },
            error: () => {
              this.scan.splits = this.scan.splits.map((split) => {
                if (split.guid === this.chosenScanSplit.guid) split.lock = false;
                return split;
              });
              this.iScanAPIService.saveSplit(this.scan.guid, this.scan.splits).subscribe();
              this.spinner.hide();
            },
          });
        },
      });
    } else {
      this.toastr.error(this.translater.translate('iScan.error.fieldsRequired'));
      this.spinner.hide();
    }
  }
}
